import axios from 'axios'

export const users = {
    state:{
        users: [],
        usersbyid: {},
        recentusers: []
    },
    mutations:{
      Users(state, data){
        state.users = data.data
      },
      RecentUsers(state, data){
        state.recentusers = data.data
      },
      UsersById(state, data){
        state.usersbyid = data.data
      },
    
    },
    actions:{
    
      // =================Users management =============
      GetUsers: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/users")
          .then(({data, status})=>{
            if(status === 200){
              commit('Users', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetRecentUsers: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/recentusers")
          .then(({data, status})=>{
            if(status === 200){
              commit('RecentUsers', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetUsersById: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get("/users/"+payload)
          .then(({data, status})=>{
            if(status === 200){
              commit('UsersById', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      ContactUs: ({commit},payload) =>{
        return new Promise((resolve, reject)=>{
          axios.post('/contactus',payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data)
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          })
        })
      },


      ActivateUser: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get('/users/activate/'+payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      DeactivateUser: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.delete('/users/'+payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      
  }
}